// AdminDashboardService.js
import { useState, useCallback } from "react";
import API from "../../api/apiAdmin";

export function useAdminDashboard() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [stats, setStats] = useState(null);

    const fetchDashboardStats = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await API.get("/admin/dashboard/stats/");
            if (res.data && res.data.status === "success") {
                setStats(res.data.data);
                return res.data.data;
            }
            throw new Error(res.data?.message || "Failed to fetch stats");
        } catch (err) {
            const msg = err.response?.data?.message || err.message || "Network error";
            setError(msg);
            console.error("Dashboard Stats Fetch Error:", msg);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        stats,
        loading,
        error,
        fetchDashboardStats,
    };
}
